export default __webpack_public_path__ + "static/media/warning.b361f9e9.svg";